import React, { useEffect, useState } from "react";
import marketingSolutionServices from "../../../../services/marketingSolution.services";
import { Card, CardContent, Button, makeStyles, Grid, Typography, Box, CircularProgress } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import appRoutes from "../../../../routes/app.routes";
import { rootReducersState } from "../../../reducers";
import { useSelector } from "react-redux";
import _ from "lodash";
import { useLocation } from "react-router-dom";
const useStyles = makeStyles((theme) => ({
  card: {
    maxWidth: 530,
    marginTop: 20,
    minHeight: 200,
    position: "relative",
    display: "flex",
    alignItems: "center",
    "& .MuiCardContent-root": {
      padding: 0,
    },
    "&:hover $hoverOverlay": {
      // boxShadow: "0px 0px 15px 0px rgba(0,0,0,0.2)",
      // border: "2px solid #ff0a90",
      opacity: 1,
    },
  },
  content: {
    textAlign: "left",
    pointerEvents: "none",
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    pointerEvents: "none",
  },
  hoverOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    opacity: 0,
    pointerEvents: "none",
  },
  loadButton: {
    pointerEvents: "auto",
  },
  emptyWrap: {
    width: "100%",
    padding: theme.spacing(6, 2),
    textAlign: "center",
  },
  emptyTitle: {
    marginBottom: theme.spacing(1),
    fontWeight: 600,
  },
  emptySubtitle: {
    marginBottom: theme.spacing(3),
    color: theme.palette.text.secondary,
    maxWidth: 420,
    marginLeft: "auto",
    marginRight: "auto",
  },
  loadingWrap: {
    width: "100%",
    padding: theme.spacing(8, 2),
    display: "flex",
    justifyContent: "center",
  },
}));

const EmailTemplates = () => {
  const [templatesList, setTemplatesList] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const classes = useStyles();
  const navigate = useNavigate();
  const sessionReducer = useSelector(
    ({ session }: rootReducersState) => session
  );
  const companySlug = sessionReducer.currentCompany.slug;
  const location = useLocation();
  const id = new URLSearchParams(location.search).get("id");
  const filteredList = templatesList?.filter(
    (item: any) => item.id === Number(id)
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res: any = await marketingSolutionServices.fetchEmailTemplates();
        if (res.flag && Array.isArray(res?.data)) {
          setTemplatesList(res.data);
        } else {
          setTemplatesList([]);
        }
      } catch (error: any) {
        console.error(error?.message ?? error);
        setTemplatesList([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleLoadDesign = (design) => {
    if (!_.isEmpty(design)) {
      // navigate({
      //   pathname: appRoutes.emailEditor.generatePath(companySlug),
      //   state: { design_json: design.design_json, id: design.template_id, is_campaign: false },
      // });
      navigate(appRoutes.emailEditor.generatePath(companySlug), {
  state: {
    design_json: design.design_json,
    id: design.template_id,
    is_campaign: false,
  },
});

    }
  };

  const listToRender =
    id && !_.isEmpty(filteredList) ? filteredList : templatesList;

  const showEmpty = !loading && _.isEmpty(listToRender);

  return (
    <Grid container spacing={4}>
      {loading && (
        <Grid item xs={12}>
          <Box className={classes.loadingWrap}>
            <CircularProgress color="primary" />
          </Box>
        </Grid>
      )}
      {!loading &&
        showEmpty &&
        (id ? (
          <Grid item xs={12}>
            <Box className={classes.emptyWrap}>
              <Typography variant="h6" component="p" className={classes.emptyTitle}>
                Template not found
              </Typography>
              <Typography variant="body2" className={classes.emptySubtitle}>
                That template is not available anymore, or this link is not valid. Go back
                to see all templates, or create a new one.
              </Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={() =>
                  navigate(appRoutes.emailTemplates.generatePath(companySlug))
                }
              >
                View all templates
              </Button>
            </Box>
          </Grid>
        ) : (
          <Grid item xs={12}>
            <Box className={classes.emptyWrap}>
              <Typography variant="h6" component="p" className={classes.emptyTitle}>
                No email templates yet
              </Typography>
              <Typography variant="body2" className={classes.emptySubtitle}>
                You have not saved any templates yet. Create one in the editor to reuse
                it for campaigns.
              </Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={() =>
                  navigate(appRoutes.createEmailTemplate.generatePath(companySlug))
                }
              >
                Create a template
              </Button>
            </Box>
          </Grid>
        ))}
      {!loading &&
        listToRender.map((template: any, index: number) => (
          <Grid item xs={id && !_.isEmpty(filteredList) ? 12 : 4} key={index}>
            <Card className={classes.card}>
              <div className={classes.overlay}></div>
              <CardContent
                className={classes.content}
                dangerouslySetInnerHTML={{ __html: template.design_html }}
              />
              <div className={classes.hoverOverlay}>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.loadButton}
                  onClick={() => handleLoadDesign(template)}
                >
                  Edit Template
                </Button>
              </div>
            </Card>
          </Grid>
        ))}
    </Grid>
  );
};

export default EmailTemplates;
